import AddCustVehicle from 'src/components/AddCustVehicle/AddCustVehicle';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { AppointmentActionCreator, FrameworkActionCreator, VehiclesActionCreator, ROHistoryActionCreator, RepairOrdersActionCreator, CustomerActionCreator, SpecsActionCreator, AdditionalServicesActionCreator } from 'src/store/states';
import { BlankDeptSpec } from 'src/models/Specs/TestSpecs';

const mapStateToProps = (state: IStoreState) => ({
    newVehicleInfo: state.NewVehicle.NewVehicle,
    decodeData: state.Vehicles.decodedData,
    vehicles: state.Vehicles.vehicles,
    custInfo: state.Customer.Customer,
    vehErr: state.Vehicles.errMsg,
    vehiclePhoto: state.Vehicles.vehiclePhoto,
    vehPhotoList: state.Vehicles.vehPhotoList,
    store: state.Framework.store,
    branch: state.Framework.branch,
    previewFlag: state.Framework.previewFlag,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    roHistory: state.ROHistory.allRoHistory,
    profileNum: state.Framework.specProfile,
    specDeptData: state.Specs.deptSpecs !== undefined ? state.Specs.deptSpecs : BlankDeptSpec,
    theme: state.Framework.theme,
    loading: state.Customer.loading,
    Itype: state.Framework.ImageServerType,
    selectedVehicle: state.Vehicles.selectedVehicle,
});

const mapDispatchToProps = {
    clearMainPane: FrameworkActionCreator.clearMainPanes,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    setViewMode: FrameworkActionCreator.acSetViewMode,
    decodeVin: VehiclesActionCreator.DecodeVin,
    clearDecodeData: VehiclesActionCreator.ClearDecodeData,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    addVehicle: VehiclesActionCreator.AddVehicle,
    getVehicles: VehiclesActionCreator.GetVehicles,
    createVehicle: VehiclesActionCreator.CreateVehicle,
    clearError: VehiclesActionCreator.VehiclesClearError,
    updateApptVehicle: AppointmentActionCreator.UpdateApptVehicle,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    getROHistory: ROHistoryActionCreator.GetROHistory,
    clearROHistory: ROHistoryActionCreator.ClearROHistory,
    selectRO: RepairOrdersActionCreator.SelectRO,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    custSearch: CustomerActionCreator.CustomerSearch,
    getDeptSpecs: SpecsActionCreator.GetDeptSpecs,
    setLoadingStateToIdle: CustomerActionCreator.SetLoadingStateToIdle,
    clearServices: AdditionalServicesActionCreator.ClearAdditionalServices,
    getServices: AdditionalServicesActionCreator.GetAdditionalServices,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddCustVehicle);